import { render, staticRenderFns } from "./redictPlatform.vue?vue&type=template&id=1076895f&"
import script from "./redictPlatform.vue?vue&type=script&lang=js&"
export * from "./redictPlatform.vue?vue&type=script&lang=js&"
import style0 from "./redictPlatform.vue?vue&type=style&index=0&id=1076895f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports